export function parseDashboardActionPayload(rawPayload) {
  if (!rawPayload) return {}

  if (typeof rawPayload === "string") {
    try {
      return JSON.parse(rawPayload)
    } catch {
      return {}
    }
  }

  if (typeof rawPayload === "object") {
    return rawPayload
  }

  return {}
}

export function buildDashboardParams(targetClinicId, extra = {}) {
  const params = new URLSearchParams()

  if (targetClinicId && targetClinicId !== "ALL") {
    params.set("clinicId", String(targetClinicId))
  }

  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value))
    }
  })

  return params.toString()
}

export function openFinancialActionRoute({
  navigate,
  target,
  targetClinicId,
  fallbackClinicId
}) {
  const params = new URLSearchParams()

  const resolvedClinicId = targetClinicId || fallbackClinicId

  if (resolvedClinicId && resolvedClinicId !== "ALL") {
    params.set("clinicId", String(resolvedClinicId))
  }

  if (target) {
    params.set("focus", String(target))
  }

  params.set("fromDashboard", "1")
  navigate(`/financial-executive?${params.toString()}`)
}

export function openDashboardActionTarget({
  action,
  navigate,
  clinicId,
  date,
  openFinancialAction
}) {
  const payload = parseDashboardActionPayload(action?.actionPayload)
  const rawTarget = String(action?.actionTarget || "").trim().toUpperCase()
  const title = String(action?.title || "").trim().toLowerCase()
  const targetClinicId = payload.clinicId || action?.clinicId || clinicId
  const normalizedFocus = String(payload?.focus || "").trim().toUpperCase()
  const normalizedTab = String(payload?.tab || "").trim().toUpperCase()

  const paramsFor = (extra = {}) =>
    buildDashboardParams(targetClinicId, extra)

  const isRecallLike =
    normalizedFocus === "RECALL" ||
    normalizedFocus === "PROMOTION" ||
    normalizedFocus === "CAMPAIGN" ||
    title.includes("recall") ||
    title.includes("promoc") ||
    title.includes("campañ") ||
    title.includes("campaign")

  if (payload?.patientId) {
    navigate(
      `/patients/${payload.patientId}?${paramsFor({
        tab: normalizedTab || "SUMMARY",
        focus: payload.focus,
        source: "dashboard"
      })}`
    )
    return
  }

  if (rawTarget === "FINANCIAL") {
    openFinancialAction(payload.focus || "top-debtors", targetClinicId)
    return
  }

  if (rawTarget === "AGENDA") {
    navigate(
      `/agenda?${paramsFor({
        focus: payload.focus,
        date: payload.date
      })}`
    )
    return
  }

  if (rawTarget === "CASH") {
    navigate(
      `/cash-closing?${paramsFor({
        date: payload.date || date
      })}`
    )
    return
  }

  if (rawTarget === "PORTFOLIO") {
    navigate(
      `/billing?${paramsFor({
        focus: payload.focus || "portfolio"
      })}`
    )
    return
  }

  if (rawTarget === "PATIENT") {
    navigate(
      `/patients?${paramsFor({
        focus: payload.focus || "recall",
        tab: normalizedTab || undefined,
        source: "dashboard"
      })}`
    )
    return
  }

  if (
    rawTarget === "PROMOTION" ||
    rawTarget === "RECALL" ||
    rawTarget === "CAMPAIGN"
  ) {
    navigate(
      `/patients?${paramsFor({
        focus: payload.focus || "recall",
        source: "dashboard"
      })}`
    )
    return
  }

  if (rawTarget === "IA" || rawTarget === "INTELLIGENT_CENTER") {
    navigate(
      `/ia?${paramsFor({
        focus: payload.focus || "recall"
      })}`
    )
    return
  }

  if (rawTarget === "DASHBOARD") {
    if (isRecallLike) {
      navigate(
        `/patients?${paramsFor({
          focus: payload.focus || "recall",
          source: "dashboard"
        })}`
      )
      return
    }

    navigate(
      `/dashboard?${paramsFor({
        focus: payload.focus,
        date: payload.date || date
      })}`
    )
    return
  }

  if (isRecallLike) {
    navigate(
      `/patients?${paramsFor({
        focus: payload.focus || "recall",
        source: "dashboard"
      })}`
    )
    return
  }

  openFinancialAction("top-debtors", targetClinicId)
}